import React__default from "react";
import { COLORS } from "../../EatClubTheme.js";
import { c as createTheme, S as StyledEngineProvider } from "../../../createTheme-dvNdIolQ.js";
import { T as ThemeProvider$1 } from "../../../ThemeProvider-DZgyuQv1.js";
const theme = createTheme({
  palette: {
    primary: {
      light: "#ff456a",
      main: "#E54439",
      dark: "#b21030",
      contrastText: "#fff"
    },
    secondary: {
      light: "#959595",
      main: "#757575",
      dark: "#555555",
      contrastText: "#fff"
    },
    error: {
      light: "#ff456a",
      main: "#E54439",
      dark: "#b21030",
      contrastText: "#fff"
    },
    warning: {
      light: "#fab85c",
      main: "#f9a32c",
      dark: "#df8507",
      contrastText: "#fff"
    }
  },
  typography: {
    fontFamily: "Gordita, Open Sans, Helvetica, sans-serif !important",
    h1: {
      fontSize: "2em",
      fontWeight: 600
    },
    h2: {
      fontSize: "1.5em",
      fontWeight: 600
    },
    h3: {
      fontSize: "1.17em",
      fontWeight: 600
    },
    h4: {
      fontSize: "1em",
      fontWeight: 500
    },
    h5: {
      fontSize: "0.83em",
      fontWeight: 500
    },
    h6: {
      fontSize: "0.67em",
      fontWeight: 500
    },
    body1: {
      fontSize: "1em",
      fontWeight: 400
    }
  },
  components: {
    MuiPopover: {
      defaultProps: {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left"
        },
        transitionDuration: {
          enter: 150,
          exit: 0
        }
      },
      styleOverrides: {
        paper: {
          borderRadius: "8px",
          boxShadow: "0px 4px 14px rgba(111, 111, 111, 0.25)",
          padding: "8px"
        }
      }
    },
    MuiButton: {
      defaultProps: {
        color: "secondary",
        disableElevation: true,
        disableRipple: true,
        size: "large"
      },
      styleOverrides: {
        root: {
          fontSize: "inherit",
          textTransform: "unset"
        },
        outlinedSecondary: {
          borderColor: COLORS.SHARK
        }
      }
    },
    MuiCheckbox: {
      defaultProps: {
        color: "secondary",
        disableFocusRipple: true,
        disableRipple: true,
        disableTouchRipple: true
      },
      styleOverrides: {
        root: {
          padding: 0
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          // borderRadius: '8px',
          // letterSpacing: '1.2px',
          // textTransform: 'uppercase'
        },
        colorSecondary: {
          // note: using secondary for disabled state
          backgroundColor: "#A0A0A0",
          color: "#FFFFFF"
        },
        colorSuccess: {
          backgroundColor: "#E3ECE3",
          color: "#447843"
        }
      }
    },
    MuiDialog: {
      defaultProps: {
        transitionDuration: {
          enter: 150,
          exit: 0
        }
      }
    },
    MuiIconButton: {
      defaultProps: {
        color: "secondary",
        disableRipple: true
      },
      styleOverrides: {
        root: {
          fontSize: "inherit",
          textTransform: "unset"
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          transition: "background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
          "&:hover": {
            backgroundColor: "#3131310a",
            "& $notchedOutline": {
              // borderColor: 'transparent',
              borderColor: COLORS.SHARK
            }
          },
          "&:focus": {
            backgroundColor: "transparent"
          },
          "&.Mui-disabled > fieldset": {
            // borderColor: 'transparent !important',
            borderColor: COLORS.SHARK
          }
        },
        adornedStart: {
          paddingLeft: "9px"
        },
        input: {
          padding: "9px"
        },
        multiline: {
          padding: "0px"
        },
        notchedOutline: {
          // borderColor: 'transparent',
          borderWidth: "1px !important",
          borderColor: COLORS.SHARK,
          transition: "border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
        }
      }
    }
    // MuiTextField: {
    //   defaultProps: {
    //     color: 'secondary',
    //   },
    // },
    // MuiTooltip: {
    //   defaultProps: {
    //     arrow: true,
    //     placement: 'top',
    //   },
    //   styleOverrides: {
    //     tooltip: {
    //       fontSize: '13px',
    //       fontWeight: 400,
    //       letterSpacing: 'normal',
    //     },
    //   },
    // },
  }
});
const ThemeProvider = ({ children }) => {
  return /* @__PURE__ */ React__default.createElement(StyledEngineProvider, { injectFirst: true }, /* @__PURE__ */ React__default.createElement(ThemeProvider$1, { theme }, children));
};
export {
  ThemeProvider
};
//# sourceMappingURL=theme.js.map
